// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xYfUbyxgGxYiBz {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.OhIH3lQ2K6jvMx {
  box-shadow: var(--ds-shadow-overlay, 0px 8px 12px #091e4226, 0px 0px 1px #091e424f);
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  width: 100%;
  max-width: 550px;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  margin-top: 56px;
  padding: var(--ds-space-400, 32px);
  border: 1px solid var(--ds-border, #091e4224);
  border-radius: var(--ds-border-radius-100, 3px);
  background: var(--ds-surface-overlay, #ffffff);
}
@media only screen and (max-width: 750px), only screen and (min-width: 751px) and (max-width: 900px) {
  .OhIH3lQ2K6jvMx {
    margin-top: var(--ds-space-0, 0);
    padding: var(--ds-space-200, 16px);
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `xYfUbyxgGxYiBz`,
	"box": `OhIH3lQ2K6jvMx`
};
export default ___CSS_LOADER_EXPORT___;
